export default "__VITE_ASSET__CKeC1DPe__"